import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "message-box-text"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: $data.model.title,
    "is-processing": _ctx.isProcessing,
    "is-visible": $data.isVisible
  }, {
    actions: _withCtx(() => [
      ($data.model.type === 'question')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($options.hasDeclineLabel)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  class: "gfu-link gfu-link--accent _ttl",
                  onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.cancel && $options.cancel(...args)), ["prevent"])),
                  "data-qa": "modal-button:No"
                }, _toDisplayString($options.getDeclineLabel), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "",
                  class: "gfu-link gfu-link--accent _ttl",
                  onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.cancel && $options.cancel(...args)), ["prevent"])),
                  "data-qa": "modal-button:No"
                }, _toDisplayString(_ctx.Resources.Common.ModalNoButton), 1 /* TEXT */)),
            ($options.hasAcceptLavel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide",
                  disabled: _ctx.isProcessing,
                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.close && $options.close(...args))),
                  "data-qa": "modal-button:Yes"
                }, _toDisplayString($options.getAcceptLabel), 9 /* TEXT, PROPS */, _hoisted_2))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide",
                  disabled: _ctx.isProcessing,
                  onClick: _cache[3] || (_cache[3] = (...args) => ($options.close && $options.close(...args))),
                  "data-qa": "modal-button:Yes"
                }, _toDisplayString(_ctx.Resources.Common.ModalYesButton), 9 /* TEXT, PROPS */, _hoisted_3))
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide",
            disabled: _ctx.isProcessing,
            onClick: _cache[4] || (_cache[4] = (...args) => ($options.close && $options.close(...args))),
            "data-qa": "modal-button:Ok"
          }, _toDisplayString(_ctx.Resources.Common.ModalOkButton), 9 /* TEXT, PROPS */, _hoisted_4))
    ]),
    default: _withCtx(() => [
      ($data.model.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($data.model.text), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-processing", "is-visible"]))
}